import { render, staticRenderFns } from "./category-header.vue?vue&type=template&id=4898adb0"
import script from "./category-header.vue?vue&type=script&lang=js"
export * from "./category-header.vue?vue&type=script&lang=js"
import style0 from "./category-header.vue?vue&type=style&index=0&id=4898adb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports